import styled from "styled-components";

import * as styles from "styles";
import * as Types from "Types";

const Wrap = styled.div<Types.Default>`
   ${styles.Typography.subtitle2}
   ${({ css }) => css}
`;

export default function Subtitle2(props: Types.Default) {
   return (
      <Wrap css={props.css} className={props.className}>
         {props.children}
      </Wrap>
   );
}
